$(document).ready(function () {
	// base url
	if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'localhost') {
		var path = '/edlex/';
	} else {
		var path = '/';
	}

	$('a[href^="#"]').click(function (e) {
		$('html').animate({ scrollTop: $(this.hash).offset().top - 150 }, 1000);
		$('.navbar-collapse').removeClass('show');
		return false;
		e.preventDefault();
	});

	$(document).on('scroll', function() {
		if ($(this).scrollTop() > 0) {
			$('.logo-tel').addClass('animate');
			// $('.logo').animate({ width: '150px' });
			// $('.menu-tel').animate({ opacity: 0 });
		} else {
			$('.logo-tel').removeClass('animate');
			// $('.logo').animate({ width: '300px' });
			// $('.menu-tel').animate({ opacity: 1 });
		}
	});

	var lang = $('html').attr('lang');
	var data_table_i18n = { 'fr': 'French', 'en': 'English', 'nl': 'Dutch' };

	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// toastr.options.timeOut = 0;
	// toastr.options.extendedTimeOut = 0;

	// init datatable
	if ($('body').find('.data-table').length > 0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
			"language": {
				"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/" + data_table_i18n[lang] + ".json"
			},
			"pageLength": 25,
			"aaSorting": []
		});

		$.fn.dataTable.moment = function (format, locale) {
			var types = $.fn.dataTable.ext.type;

			// Add type detection
			types.detect.unshift(function (d) {
				return moment(d, format, locale, true).isValid() ?
					'moment-' + format :
					null;
			});

			// Add sorting method - use an integer for the sorting
			types.order['moment-' + format + '-pre'] = function (d) {
				return moment(d, format, locale, true).unix();
			};
		};

		$.fn.dataTable.moment('DD-MM-YYYY');
	}

	// init datatable
	if ($('body').find('.data-table-facturation').length > 0) {
		//var language = $('html').attr('lang');
		$('.data-table-facturation').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: false
			},
			paging: false,
			info: false,
			"language": {
				"url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/" + data_table_i18n[lang] + ".json"
			},
			"pageLength": 5,
			"aaSorting": []
		});
	}

	// init datepicker
	$('.datepicker').datepicker({
		format: "dd-mm-yyyy",
		weekStart: 1,
		daysOfWeekDisabled: "0,6",
		startDate: '0d'
	});

	// init selectpicker
	$('.selectpicker').selectpicker();
	$(document).on('click', '.bootstrap-select button', function (e) {
		e.preventDefault();
		return false;
	});

	// mise à jour du prix dans le process de commande
	function price() {
		var share = $('input[name="share"]:checked').val();
		var type = $('input[name="type"]').val();
		var tmp = $('input[name="tmp"]').val();

		$.getJSON(path + 'Connections/request/xhr/commande/get-price.php', { share: share, type: type, order: tmp }, function (response) {
			if (response.action == 'success') {
				$('#get-price #price_htva').html(response.formated_price.price_htva);
				$('#get-price #tva').html(response.formated_price.tva);
				$('#get-price #price_ttc').html(response.formated_price.price_ttc);
				$('#get-price #price_ttc_base').html(response.formated_price.price_ttc_base);
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});
	}

	if ($('#get-price').length > 0) {
		price();
	}

	$(document).on('change', 'input[name="share"]:checked', function (e) {
		price();

		e.preventDefault();
		return false;

	});

	// update des données du user
	$(document).on('submit', '#form-user-data', function (e) {
		var data = $(this).serializeArray();

		$.getJSON(path + 'Connections/request/xhr/membre/update-user-data.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// ajout des données de facturation
	$(document).on('click', '#add-facturation', function (e) {
		var data = $('#form-user-facturation').serializeArray();

		$.getJSON(path + 'Connections/request/xhr/facturation/add-facturation.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-address-facturation').toggle();
				location.reload();
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// ajout des données de facturation
	$(document).on('submit', '#form-contact', function (e) {
		$('.alert').removeClass('alert-success alert-danger').html('').hide();

		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path + 'Connections/request/xhr/contact/send-contact.php', data, function (response) {
			if (response.action == 'success') {
				$('.alert').addClass('alert-success').html('<i class="fa fa-check mr-2"></i> ' + response.msg).show();
				$('#form-contact').hide();
				// $('input, textarea, select').each(function(){
				// 	$(this).val('');
				// 	$('input[type=checkbox]').prop('checked', false);
				// });
			}
			else {
				$('.alert').addClass('alert-danger').html('<i class="fa fa-times mr-2"></i> ' + response.msg).show();
			}
		});

		e.preventDefault();
		return false;
	});

	//
	$(document).on('click', '#add-address-facturation', function (e) {
		$('#update-facturation').addClass('d-none');
		$('#add-facturation').removeClass('d-none');

		// clean form
		$('#modal-address-facturation').find('input:not([type=radio]), textarea').val('');

		$('#modal-address-facturation').modal('show');
		e.preventDefault();
	});

	// modal update des données de facturation
	$(document).on('click', '.update-facturation', function (e) {
		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path + 'Connections/request/xhr/facturation/get-facturation.php', { id: id }, function (response) {
			if (response.action == 'success') {
				$('#update-facturation').removeClass('d-none');
				$('#add-facturation').addClass('d-none');

				$.each(response.facturation, function (key, value) {
					$('#' + key).val(value);
				});

				$('#id_facturation, #id_factu').val(id);

				$('#modal-address-facturation').modal('show');
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});


	// modification des données de facturation
	$(document).on('click', '#update-facturation', function (e) {
		var data = $('#form-user-facturation').serializeArray();

		$.getJSON(path + 'Connections/request/xhr/facturation/update-facturation.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-address-facturation').toggle();
				location.reload();
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('click', '.delete-facturation', function (e) {
		var id = $(this).closest('[data-id]').data('id');
		var $this = $(this);
		$.confirm({
			columnClass: 'col-12',
			theme: 'supervan',
			title: 'Suppression',
			content: 'Êtes-vous sûr de vouloir supprimer cette adresse de facturation ?',
			buttons: {
				Annuler: function () {
					//$this.find('input').prop('checked', false);
				},
				Confirmer: {
					btnClass: 'btn-primary',
					action: function () {
						$.getJSON(path + 'Connections/request/xhr/facturation/delete-facturation.php', { id: id }, function (response) {
							if (response.action == 'success') {
								toastr.success(response.msg);
								$this.closest('[data-id]').remove();
							}
							else if (response.action == 'empty') {
								toastr.warning(response.msg);
							}
							else {
								toastr.error(response.msg);
							}
						});

					}
				}
			}
		});

		e.preventDefault();
	});

	// ajout des données de biens
	$(document).on('click', '#add-estate', function (e) {
		var data = $('#form-user-estate').find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path + 'Connections/request/xhr/estate/add-estate.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-address-estate').toggle();
				location.reload();
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	//
	$(document).on('click', '#add-address-estate', function (e) {
		$('#update-estate').addClass('d-none');
		$('#add-estate').removeClass('d-none');

		// clean form
		$('#modal-address-estate').find('input:not(:radio), textarea').val('');
		$('#modal-address-estate input[name="Meuble"]').prop('checked', false);
		$('#modal-address-estate').find('select').val('0');
		$('#modal-address-estate .selectpicker').selectpicker('refresh');

		$('#modal-address-estate').modal('show');
		e.preventDefault();
	});

	// modal update des données de biens
	$(document).on('click', '.update-estate', function (e) {
		var id = $(this).closest('[data-id]').data('id');

		$.getJSON(path + 'Connections/request/xhr/estate/get-estate.php', { id: id }, function (response) {
			if (response.action == 'success') {
				$('#update-estate').removeClass('d-none');
				$('#add-estate').addClass('d-none');

				$.each(response.estate, function (key, value) {
					if (key == 'Meuble') {
						if (value == 1) {
							$('#' + key).prop('checked', true);
							$('#Non_meuble').prop('checked', false);
						}
						else {
							$('#' + key).prop('checked', false);
							$('#Non_meuble').prop('checked', true);
						}
					}
					else {
						$('#' + key).val(value);
						$('.selectpicker').selectpicker('refresh')
					}
				});

				$('#id_estate').val(id);

				if ($('#Type_bien').val() == 'maison') {
					$('#Etage').closest('.form-group').addClass('d-none');
					$('#Numero_bien').closest('.form-group').addClass('d-none');
					$('#Numero_cave').closest('.form-group').addClass('d-none');
					$('#Numero_parking').closest('.form-group').addClass('d-none');
				}
				else {
					$('#Etage').closest('.form-group').removeClass('d-none');
					$('#Numero_bien').closest('.form-group').removeClass('d-none');
					$('#Numero_cave').closest('.form-group').removeClass('d-none');
					$('#Numero_parking').closest('.form-group').removeClass('d-none');
				}

				if ($('#Type_bien').val() == 'studio') {
					$('#Nbr_chambre').closest('.form-group').addClass('d-none');
					$('.hide-studio').removeClass('d-none');
					$('.hide-studio').prev('.form-group').removeClass('offset-md-2');
				}
				else {
					$('#Nbr_chambre').closest('.form-group').removeClass('d-none');
					$('.hide-studio').addClass('d-none');
					$('.hide-studio').prev('.form-group').addClass('offset-md-2');
				}

				$('#modal-address-estate').modal('show');
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification des données de biens
	$(document).on('click', '#update-estate', function (e) {

		var data = $('#form-user-estate').find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path + 'Connections/request/xhr/estate/update-estate.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-address-estate').toggle();
				location.reload();
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('click', '.delete-estate', function (e) {
		var id = $(this).closest('[data-id]').data('id');
		var $this = $(this);
		$.confirm({
			columnClass: 'col-12',
			theme: 'supervan',
			title: 'Suppresion',
			content: 'Êtes-vous sûr de vouloir supprimer ce bien ?',
			buttons: {
				Annuler: function () {
					//$this.find('input').prop('checked', false);
				},
				Confirmer: {
					btnClass: 'btn-primary',
					action: function () {
						$.getJSON(path + 'Connections/request/xhr/estate/delete-estate.php', { id: id }, function (response) {
							if (response.action == 'success') {
								toastr.success(response.msg);
								$this.closest('[data-id]').remove();
							}
							else if (response.action == 'empty') {
								toastr.warning(response.msg);
							}
							else {
								toastr.error(response.msg);
							}
						});

					}
				}
			}
		});

		e.preventDefault();
	});


	// afficher/masquer champs étage dans la fiche du bien si maison sélectionné
	$(document).on('change', '#Type_bien', function (e) {
		if ($(this).val() == 'maison') {
			$('#Etage').closest('.form-group').addClass('d-none');
			$('#Numero_bien').closest('.form-group').addClass('d-none');
			$('#Numero_cave').closest('.form-group').addClass('d-none');
			$('#Numero_parking').closest('.form-group').addClass('d-none');
		}
		else {
			$('#Etage').closest('.form-group').removeClass('d-none');
			$('#Numero_bien').closest('.form-group').removeClass('d-none');
			$('#Numero_cave').closest('.form-group').removeClass('d-none');
			$('#Numero_parking').closest('.form-group').removeClass('d-none');
		}

		if ($(this).val() == 'studio') {
			$('#Nbr_chambre').closest('.form-group').addClass('d-none');
			$('.hide-studio').removeClass('d-none');
			$('.hide-studio').prev('.form-group').removeClass('offset-md-2');
		}
		else {
			$('#Nbr_chambre').closest('.form-group').removeClass('d-none');
			$('.hide-studio').addClass('d-none');
			$('.hide-studio').prev('.form-group').addClass('offset-md-2');
		}

		e.preventDefault();
		return false;
	});

	$(document).on('change', '#files_upload', function (e) {
		var files = $('#files_upload').prop('files');
		var formData = new FormData(document.getElementById('form_upload'));
		formData.append('file', files);

		$(this).after('<i class="fas fa-circle-notch fa-spin mr-2"></i>');

		$.ajax({
			url: path + 'Connections/request/xhr/commande/upload_files.php',
			dataType: 'json',
			cache: false,
			contentType: false,
			processData: false,
			data: formData,
			type: 'post',
			success: function (response) {
				if (response.action == 'success') {

					if ($('#upload_list').length == 0) {
						$('#form_upload').before('<ul id="upload_list"></ul>');
					} else {
						$('#upload_list').html('');
					}
					$(response.docs.name).each(function (index, value) {
						$('#upload_list').append('<li>' + value + ' <a class="delete_file" data-name="' + value + '" data-key="' + index + '" style="cursor:pointer;"><i class="fa fa-times fa-fw" style="color:darkred;"></i></a></li>');
					});
					$('.fa-circle-notch').remove();

					$('#files_upload').val('');

				} else if (response.action == 'bad_ext') {
					toastr.error(response.msg);
					$('.fa-circle-notch').remove();
				} else if (response.action == 'file_exists') {
					toastr.error(response.msg);
					$('.fa-circle-notch').remove();
				}
			}
		});

	});

	$(document).on('click', '.delete_file', function () {
		var file_key = $(this).data('key');
		var file_name = $(this).data('name');
		var $this = $(this);

		$.post(path + 'Connections/request/xhr/commande/delete_doc.php', { 'file_key': file_key, 'file_name': file_name }, function (response) {
			if (response.action == "success") {
				$this.parent('li').remove();
			}
		}, 'json');
	});

	$(document).on('click', '[data-value], .next', function (e) {
		var step = $(this).closest('[data-step]').data('step');
		var $this = $(this);
		var data = $(this).closest('section').find('input, textarea').serializeArray();

		data[data.length] = { name: 'step', value: step };

		if (step == 'service') {
			data[data.length] = { name: 'data', value: $(this).data('value') };
		}

		// if (step == 'date') {

		// 	var files = $('#files_upload').prop('files');
		// 	var formData = new FormData(document.getElementById('form_dates'));
		// 	formData.append('file', files);
		// 	formData.append('step', step);

		// 	$.ajax({
		// 		url: path+'Connections/request/xhr/commande/step.php',
		// 		dataType: 'json',  
		// 		cache: false,
		// 		contentType: false,
		// 		processData: false,
		// 		data: formData,                         
		// 		type: 'post',
		// 		success: function(response){
		// 			if(response.action == 'success') {
		// 				location.href = response.url;
		// 			}
		// 			else if(response.action == 'empty') {
		// 				toastr.warning(response.msg);
		// 			}
		// 			else if(response.action == 'error' && response.msg == 'Disconnected') {
		// 				location.href = response.url;
		// 			}
		// 			else {
		// 				toastr.error(response.msg);
		// 			}
		// 		}
		// 	});

		// } else {

		$.getJSON(path + 'Connections/request/xhr/commande/step.php', data, function (response) {
			if (response.action == 'success') {
				location.href = response.url;
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if (response.action == 'error' && response.msg == 'Disconnected') {
				location.href = response.url;
			}
			else {
				toastr.error(response.msg);
			}
		});

		// }

		e.preventDefault();
	});

	$(document).on('click', '.bien', function (e) {
		var value = $(this).data('id');
		var $this = $(this);

		$('.bien').removeClass('active');
		$(this).addClass('active');

		$('#id_bien').val(value);

		e.preventDefault();
	});

	$(document).on('click', '.exchange-facturation', function (e) {
		var id = $(this).closest('tr').data('id');

		$.getJSON(path + 'Connections/request/xhr/facturation/exchange-facturation.php', { id: id }, function (response) {
			if (response.action == 'success') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$(document).on('click', '.paiement', function (e) {
		var type = $(this).data('type');
		var $this = $(this);

		$('.paiement').removeClass('active');
		$(this).addClass('active');
		$('.billing > div').hide();
		$('#valid-virement, #valid-carte, #valid-bancontact, #valid-cash').hide();
		$('.billing').slideDown();
		$('#' + type).show();
		$('#valid-' + type).show();

		e.preventDefault();
	});
	var loadShow = 0;
	$(document).on('click', '#valid-cash', function (e) {
		if (loadShow == 0) {
			var type = $('#valid-cash').data('pay');
			var token = $(this).closest('[data-token]').data('token');
			var order = $('#order').val();

			if (!$('#share').is(':checked') && !$('#dontshare').is(':checked')) {

				toastr.warning('Veuillez remplir tous les champs obligatoires');

			} else {

				if ($('#share').is(':checked')) {
					var share = 1;
				}
				else {
					var share = 0;
				}
				var $this = $(this);

				$('a[data-pay]').html('<i class="fas fa-circle-notch fa-spin mr-2"></i>');
				loadShow = 1;

				$.post(path + 'Connections/stripe/create_intent.php', { type: type, token: token, order: order, share: share }, function (response) {

					console.log(response);
					if (response.action == 'success') {
						location.href = response.url;
					}
					else if (response.action == 'empty') {
						toastr.warning(response.msg);
					}
					else {
						toastr.error(response.msg);
					}

				}, 'json');

			}

			e.preventDefault();
		}
	});

	$(document).on('click', '#valid-virement', function (e) {
		if (loadShow == 0) {
			var type = $('#valid-virement').data('pay');
			var token = $(this).closest('[data-token]').data('token');
			var order = $('#order').val();
			if ($('#share').is(':checked')) {
				var share = 1;
			}
			else {
				var share = 0;
			}
			var $this = $(this);

			$('a[data-pay]').html('<i class="fas fa-circle-notch fa-spin mr-2"></i>');
			loadShow = 1;
			$.post(path + 'Connections/stripe/create_intent.php', { type: type, token: token, order: order, share: share }, function (response) {
				if (response.action == 'success') {
					location.href = response.url;
				}
				else if (response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else {
					toastr.error(response.msg);
				}

			}, 'json');

			e.preventDefault();
		}
	});

	$(document).on('click', '#valid-bancontact', function (e) {
		if (loadShow == 0) {
			var type = $('#valid-bancontact').data('pay');
			var token = $(this).closest('[data-token]').data('token');
			if ($('#share').is(':checked')) {
				var share = 1;
			}
			else {
				var share = 0;
			}
			var order = $('#order').val();
			var $this = $(this);

			$('a[data-pay]').html('<i class="fas fa-circle-notch fa-spin mr-2"></i>');
			loadShow = 1;
			$.post(path + 'Connections/stripe/create_intent.php', { type: type, token: token, order: order, share: share }, function (response) {

				if (response.action == 'success') {
					location.href = response.url;
				}
				else if (response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else {
					toastr.error(response.msg);
				}

			}, 'json');

			e.preventDefault();
		}
	});

	$(document).on('click', '.table .toggle-btn', function (e) {
		var $this = $(this);

		if ($(this).closest('tr').find('span.toggle').is(':hidden')) {
			$('table span.toggle').hide();
			$(this).closest('tr').find('span.toggle').show();
		}
		else {
			$('table span.toggle').hide();
		}
		e.preventDefault();
	});

	// STRIPE
	if ($('body').find('div[id=card-number]').length > 0) {

		if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'edlex.test.spleen-creation.be') {
			var publicKey = 'pk_test_7IHJ3NLmLbVJzu04tCGVCj4n';
		} else {
			var publicKey = 'pk_live_TtECIrcaIMqYBqfxZ77ox5xN';
			// var publicKey = 'pk_test_7IHJ3NLmLbVJzu04tCGVCj4n';
		}

		var stripe = Stripe(publicKey);
		var elements = stripe.elements();

		var style = {
			base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
					color: 'lightgrey'
				}
			},
			invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			}
		};

		if ($('#card-number').length > 0) {

			var cardNumber = elements.create('cardNumber', { placeholder: 'Numéro de carte', style: style });
			cardNumber.mount('#card-number');
			var cardExpiry = elements.create('cardExpiry', { placeholder: 'MM/AA', style: style });
			cardExpiry.mount('#card-expiry');
			var cardCvc = elements.create('cardCvc', { placeholder: 'CVC', style: style });
			cardCvc.mount('#card-cvc');

			// Handle real-time validation errors from the card Element.
			function displayErrors(elem) {
				elem.addEventListener('change', function (event) {
					var displayError = document.getElementById('card-errors');
					if (event.error) {
						displayError.classList.add("alert", "alert-danger");
						displayError.textContent = event.error.message;
					} else {
						displayError.classList.remove("alert", "alert-danger");
						displayError.textContent = '';
					}
				});
			}
			displayErrors(cardNumber);
			displayErrors(cardExpiry);
			displayErrors(cardCvc);

		}

		// Handle form submission.
		var form = document.getElementById('valid-carte');
		form.addEventListener('click', function (event) {

			event.preventDefault();

			var type = $('#valid-carte').data('pay');
			var token = $('#valid-carte').closest('[data-token]').data('token');
			if ($('#share').is(':checked')) {
				var share = 1;
			}
			else {
				var share = 0;
			}
			var order = $('#order').val();

			var stripe_token;
			if (cardNumber.length > 0) {
				stripe.createToken(cardNumber).then(function (result) {
					if (result.token) {
						stripe_token = result.token;
					}
				});
			}

			var data = { 'type': type, 'token': token, 'share': share, 'order': order, 'stripe_token': stripe_token };

			$.post(path + 'Connections/stripe/create_intent.php', data, function (response) {

				if (response.action == 'success') {

					var clientSecret = response.client_secret;

					stripe.handleCardPayment(clientSecret, cardNumber, {
						payment_method_data: {
							billing_details: {
								address: {
									city: response.city,
									line1: response.address,
									postal_code: response.zip
								},
								email: response.email,
								name: response.name
							}
						}
					}).then(function (resp) {

						console.log(resp);

						if (resp.error) {
							toastr.error(resp.error.message);
						} else {
							location.href = response.url;
						}

					});

				} else if (response.action == 'empty') {

					toastr.warning(response.msg);

				} else {

					toastr.error(response.msg);

				}

			}, 'json');

		});
	}
	// FIN STRIPE

	// création d'un user
	$(document).on('submit', '#form-new-account', function (e) {
		var data = $(this).serializeArray();

		$.getJSON(path + 'Connections/request/xhr/membre/add-account.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-recovery', function (e) {
		var data = $(this).serializeArray();

		$.getJSON(path + 'Connections/request/xhr/membre/recovery.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				//location.href = response.url;
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('keyup', '#form-new-account input[name=password]', function () {
		var password = $('#form-new-account input[name=password]').val();
		check_pw('#form-new-account input[name=password]');
	});

	$(document).on('keyup', '#form-update-password input[name=password], #form-update-password input[name=repassword]', function () {
		var password = $('#form-update-password input[name=password]').val();
		var repassword = $('#form-update-password input[name=repassword]').val();
		check_pw('#form-update-password input[name=password]');

		if ($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}

	});

	$(document).on('keyup', '#form-password input[name=password], #form-password input[name=repassword]', function () {
		var password = $('#form-password input[name=password]').val();
		var repassword = $('#form-password input[name=repassword]').val();
		check_pw('#form-password input[name=password]');

		if ($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}

	});

	// recovery du mot de passe
	$(document).on('submit', '#form-password', function (e) {
		var data = $(this).serializeArray();

		$.getJSON(path + 'Connections/request/xhr/membre/password.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification du mot de passe
	$(document).on('submit', '#form-update-password', function (e) {
		var data = $(this).serializeArray();

		$.getJSON(path + 'Connections/request/xhr/membre/update-password.php', data, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);

				$('input[type=password]').each(function () {
					$(this).val('');
				});

				$('ul.list-styled li').removeClass('valid-regex');
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('click', '.send-paiement', function (e) {
		var id = $(this).closest('tr').data('id');

		$.getJSON(path + 'Connections/request/xhr/membre/send-paiement.php', { id: id }, function (response) {
			if (response.action == 'success') {
				toastr.success(response.msg);
			}
			else if (response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	// CASE INSENSITIVE FUNCTION.
	jQuery.expr[':'].contains = function (a, i, m) {
		var rExps = [
			{ re: /[\xC0-\xC6]/g, ch: "A" },
			{ re: /[\xE0-\xE6]/g, ch: "a" },
			{ re: /[\xC8-\xCB]/g, ch: "E" },
			{ re: /[\xE8-\xEB]/g, ch: "e" },
			{ re: /[\xCC-\xCF]/g, ch: "I" },
			{ re: /[\xEC-\xEF]/g, ch: "i" },
			{ re: /[\xD2-\xD6]/g, ch: "O" },
			{ re: /[\xF2-\xF6]/g, ch: "o" },
			{ re: /[\xD9-\xDC]/g, ch: "U" },
			{ re: /[\xF9-\xFC]/g, ch: "u" },
			{ re: /[\xC7-\xE7]/g, ch: "c" },
			{ re: /[\xD1]/g, ch: "N" },
			{ re: /[\xF1]/g, ch: "n" }
		];

		var element = $(a).text();
		var search = m[3];

		$.each(rExps, function () {
			element = element.replace(this.re, this.ch);
			search = search.replace(this.re, this.ch);
		});

		return element.toUpperCase()
			.indexOf(search.toUpperCase()) >= 0;
	};

	$(document).on('keyup  change', '#search_estate', function (e) {
		var search = $(this).val();

		if (search.length == 0) {
			$('.estate').fadeIn('fast');
		}
		else {
			if ($('.estate h5:contains(' + search + ')').length == 0 && $('.estate p:contains(' + search + ')').length == 0) {
				$('.empty_result').fadeIn();
				$('.empty_result .search').html(search);
			}
			else {
				$('.empty_result').fadeOut();
			}
			$('.estate h5:not(:contains(' + search + ')), .estate p:not(:contains(' + search + '))').closest('.estate').hide();
			$('.estate h5:contains(' + search + '), .estate p:contains(' + search + ')').closest('.estate').show();
		}
	});

	$(document).on('keyup  change', '#search_facturation', function (e) {
		var search = $(this).val();

		if (search.length == 0) {
			$('.facturation').fadeIn('fast');
		}
		else {
			if ($('.facturation h5:contains(' + search + ')').length == 0 && $('.facturation p:contains(' + search + ')').length == 0) {
				$('.empty_result').fadeIn();
				$('.empty_result .search').html(search);
			}
			else {
				$('.empty_result').fadeOut();
			}
			$('.facturation h5:not(:contains(' + search + ')), .facturation p:not(:contains(' + search + '))').closest('.facturation').hide();
			$('.facturation h5:contains(' + search + '), .facturation p:contains(' + search + ')').closest('.facturation').show();
		}
	});
});

function onSubmit(token) {
	// document.getElementById("form-contact").submit();

	$('.alert').removeClass('alert-success alert-danger').html('').hide();

	var data = $('#form-contact').serializeArray();

	$.post('/Connections/request/xhr/contact/send-contact.php', data, function (response) {
		if (response.action == 'success') {
			$('.alert').addClass('alert-success').html('<i class="fa fa-check mr-2"></i> ' + response.msg).show();
			$('#form-contact').hide();
			// $('input, textarea, select').each(function(){
			// 	$(this).val('');
			// 	$('input[type=checkbox]').prop('checked', false);
			// });
		}
		else {
			$('.alert').addClass('alert-danger').html('<i class="fa fa-times mr-2"></i> ' + response.msg).show();
		}
	}, 'json');
}

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if (lowerCasePattern.test(pw)) {
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

	// At least one UPPERCASE character:
	var upperCasePattern = /^(?=.*[A-Z]).+$/;

	if (upperCasePattern.test(pw)) {
		$('.uppercase').addClass('valid-regex');
	}
	else {
		$('.uppercase').removeClass('valid-regex');
		test = false;
	}

	// At least one NUMBER:
	var numberPattern = /^(?=.*[\d]).+$/;

	if (numberPattern.test(pw)) {
		$('.number').addClass('valid-regex');
	}
	else {
		$('.number').removeClass('valid-regex');
		test = false;
	}

	// At least one SPECIAL character:
	var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

	if (specialCharacterPattern.test(pw)) {
		$('.specialcase').addClass('valid-regex');
	}
	else {
		$('.specialcase').removeClass('valid-regex');
		test = false;
	}

	// At least 8 characters in the screen:
	var characterCountPattern = /^.{8,}/;

	if (characterCountPattern.test(pw)) {
		$('.minimumcase').addClass('valid-regex');
	}
	else {
		$('.minimumcase').removeClass('valid-regex');
		test = false;
	}

	if ($('.not-secure li').length == $('.valid-regex').length) {
		$this.closest('form').addClass('valid');
	}
	else {
		$this.closest('form').removeClass('valid');
	}
}
$(document).ready(function (e) {

	$("#openModalPrix").click(function () {
		$('#modalPrix').modal('show');
	});
});
